import config from "../../config.json";
import { reportApiError } from "../errors/presentError";
import { apiGet } from "./http";
const BASE_AUTH_API = config.BASE_AUTH_API;

export const createTicketAPI = async (token, data) => {
  let responseData;
  try {
    await fetch(`${BASE_AUTH_API}team-ticket`, {
      method: "POST",
      headers: {
        Accept: "application/form-data",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));

    if (responseData.success) {
      return responseData.ticket;
    } else {
      return;
    }
  } catch (error) {
    reportApiError(error);
    return;
  }
};
export const updateTicketAPI  = async (token, id, data) => {
  let responseData;
  try {
    await fetch(`${BASE_AUTH_API}team-ticket/${id}`, {
      method: "PATCH",
      headers: {
        Accept: "application/form-data",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));

    if (responseData.success) {
      return responseData.ticket;
    } else {
      return;
    }
  } catch (error) {
    reportApiError(error);
    return;
  }
};
export const fetchTeamTicketAPI = async (token) => {
  let responseData;
  try {
    await fetch(`${BASE_AUTH_API}team-ticket`, {
      method: "GET",
      headers: {
        Accept: "application/form-data",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));

    if (responseData.success) {
      return responseData.tickets;
    } else {
      return;
    }
  } catch (error) {
    reportApiError(error);
    return;
  }
};
export const fetchTicketByIdAPI = async (token, id) => {
  let responseData;
  try {
    await fetch(`${BASE_AUTH_API}team-ticket/${id}`, {
      method: "GET",
      headers: {
        Accept: "application/form-data",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));

    if (responseData.success) {
      return responseData;
    } else {
      return;
    }
  } catch (error) {
    reportApiError(error);
    return;
  }
};
export const fetchTicketsAPI = async (token) => {
  let responseData;
  try {
    await fetch(`${BASE_AUTH_API}team-ticket/ticket-messages`, {
      method: "GET",
      headers: {
        Accept: "application/form-data",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));

    if (responseData.success) {
      return responseData;
    } else {
      return;
    }
  } catch (error) {
    reportApiError(error);
    return;
  }
};
export const TicketMessageAPI = async (token, id, data) => {
  let responseData;
  try {
    await fetch(`${BASE_AUTH_API}team-ticket/${id}`, {
      method: "POST",
      headers: {
        Accept: "application/form-data",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));

    if (responseData.success) {
      return responseData;
    } else {
      return;
    }
  } catch (error) {
    reportApiError(error);
    return;
  }
};
export const fetchTeamUsersAPI = async (token) => {
  let responseData;
  try {
    await fetch(`${BASE_AUTH_API}team-ticket/users`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));

    if (responseData.success) {
      return responseData.users;
    } else {
      return;
    }
  } catch (error) {
    console.log(error.message);
    return;
  }
};

export const deleteTicketAPI = async (token, id) => {
  let responseData;
  try {
    await fetch(`${BASE_AUTH_API}team-ticket/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/form-data",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));

    if (responseData.success) {
      console.log(responseData.message);
      return true;
    } else {
      return;
    }
  } catch (error) {
    reportApiError(error);
    return;
  }
};

// Phase 4C-2 (TICKET_SUMMARY): per-day, per-status counts of ONE month, replacing the full message list. Resolves to
// { ok, status, data, aborted? } so the chart can show a retry instead of silently loading every message.
export const fetchTicketMessageSummaryAPI = (token, { month, tz, senderIds = [], signal } = {}) =>
  apiGet("team-ticket/ticket-messages/summary", { month, tz, senderIds: senderIds.length ? senderIds.join(",") : undefined }, { token, signal });

// Phase 4C-2 (TICKET_CHAT_PAGING): one ticket with its newest `limit` messages, or the page older than the `before` cursor.
export const fetchTicketPageAPI = (token, id, { limit, before, signal } = {}) =>
  apiGet(`team-ticket/${id}`, { limit, before }, { token, signal });
